import React, { Fragment } from 'react';
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs';
import { LearningListTitle, LearningTitle } from '../../../../Utils/Constants';
import { Col, Container, Row } from 'reactstrap';
import BlogBoxList from './BlogBoxList';
import BlogBoxGrid from './BlogBoxGrid';
import LearningFilter from '../Common/LearningFilter';

export default function LearningListContainer() {
  return (
    <Fragment>
      <Breadcrumbs pageTitle={LearningListTitle} parent={LearningTitle} title={LearningListTitle} />
      <Container fluid>
        <Row>
          <Col xl={9} className="xl-60 order-xl-0 order-1 box-col-12">
            <Row>
              <BlogBoxList />
              <BlogBoxGrid />
            </Row>
          </Col>
          <LearningFilter />
        </Row>
      </Container>
    </Fragment>
  )
}
